import script from "./PwaReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./PwaReport.vue?vue&type=script&setup=true&lang=ts"

import "./PwaReport.vue?vue&type=style&index=0&id=6271350a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6271350a"]])

export default __exports__